import { render, staticRenderFns } from "./RagCreate.vue?vue&type=template&id=a2c4708a&scoped=true"
import script from "./RagCreate.vue?vue&type=script&lang=js"
export * from "./RagCreate.vue?vue&type=script&lang=js"
import style0 from "./RagCreate.vue?vue&type=style&index=0&id=a2c4708a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c4708a",
  null
  
)

export default component.exports